import React from 'react';

const SkipLink = () => (
  <a className="skip-link" href="#main-content">
    Skip to content
  </a>
);

export default SkipLink;
